import { createBrowserHistory } from 'history'

//forceRefresh: forces the page to fully reload from the server whenever a navigation occurs.
// re-run all of JavaScript code
export const history = new createBrowserHistory({ forceRefresh: true })
